module.exports = __webpack_public_path__ + "static/highlight-pattern-4ad6d7e82a87737cfc209de0eeaf996f.svg";